import { render, staticRenderFns } from "./guard_houses.vue?vue&type=template&id=25100020&scoped=true"
import script from "./guard_houses.vue?vue&type=script&lang=js"
export * from "./guard_houses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25100020",
  null
  
)

export default component.exports